import LangController from './LangController'

export default LangController
